module.exports = __webpack_public_path__ + "static/img/2.fdd47b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/2.png
// module id = N26q
// module chunks = 1